import { ApiSelect } from "@/types/apiSelect";
import { create } from "zustand";

export type SelectContextType = {
  globalsSecrets: ApiSelect[];
  setGlobalsSecrets: (globalsSecrets: ApiSelect[]) => void;
};

export const useSelectContext = create<SelectContextType>((set) => ({
  globalsSecrets: [],
  setGlobalsSecrets(globalsSecrets) {
    set({ globalsSecrets });
  },
}));
